import { getAccesToken } from "@Components";

export enum CallStatus {
  CALLING_CUSTOMER = "CALLING_CUSTOMER",
  CUSTOMER_ANSWERED = "CUSTOMER_ANSWERED",
  ONGOING = "ONGOING",
}

export interface IQueueCallback {
  id?: number;
  target_number?: number;
  end_time?: Date;
  createdAt?: Date;
  voiceCall?: { id?: number };
  status?: CallStatus;
}

//

export const getQueuedVoiceCalls = async (query: string): Promise<IQueueCallback[]> => {
  const response = (await fetch(
    process.env.REACT_APP_VOICE_BASE_URL + `/api/v1/queued_voice_call/?q=${query}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccesToken(),
      },
    }
  )) as any;

  if (!response.ok) {
    throw new Error(`Failed to fetch queue callback: ${response.statusText}`);
  }

  const json = await response.json();
  return Array.isArray(json.data) ? json.data : [];
};
